import React from "react";
import { Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

const dummyData = [
  { property: "Sunset Apartments", units: 12, totalRent: 12000000, contact: "john@example.com" },
  { property: "Green Villas", units: 8, totalRent: 8000000, contact: "jane@example.com" },
  { property: "City Heights", units: 20, totalRent: 20000000, contact: "bob@example.com" },
];

const headers = [
  { label: "Property", key: "property" },
  { label: "Units", key: "units" },
  { label: "Total Rent Collected", key: "totalRent" },
  { label: "Contact", key: "contact" },
];

function downloadCSV(data, filename = "landlord_report.csv") {
  const csvRows = [];
  // Add headers
  csvRows.push(headers.map(h => `"${h.label}"`).join(","));
  // Add data
  data.forEach(row => {
    csvRows.push(headers.map(h => `"${row[h.key]}"`).join(","));
  });
  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function downloadExcel(data, filename = "landlord_report.xlsx") {
  const worksheet = XLSX.utils.json_to_sheet(data, { header: headers.map(h => h.label) });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  XLSX.writeFile(workbook, filename);
}

const DummyReportDownload = () => (
  <Box>
    <Typography variant="h5" mb={2}>Landlord Report</Typography>
    <Stack direction="row" spacing={2} mb={2}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        onClick={() => downloadCSV(dummyData)}
      >
        Download CSV
      </Button>
      <Button
        variant="contained"
        color="success"
        startIcon={<DownloadIcon />}
        onClick={() => downloadExcel(dummyData)}
      >
        Download Excel
      </Button>
    </Stack>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map(h => (
              <TableCell key={h.key}>{h.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {dummyData.map((row, idx) => (
            <TableRow key={idx}>
              {headers.map(h => (
                <TableCell key={h.key}>{row[h.key]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default DummyReportDownload; 